<script setup>
import { computed } from 'vue'

import ImportShipCard from '@/components/import-ship/ImportShipCard.vue'

const props = defineProps({
  dialog: { type: Boolean, required: true }
})

const emit = defineEmits(['setDialog'])

const dialogValue = computed({
  get() {
    return props.dialog
  },
  set(value) {
    emit('setDialog', value)
  }
})
</script>

<template>
  <v-dialog
    v-model="dialogValue"
    height="85vh"
  >
    <ImportShipCard @close="dialogValue = false" />
  </v-dialog>
</template>
